import React from "react";
import serOne from "../../common/images/ser-n-1.png";
import serTwo from "../../common/images/ser-n-2.png";
import serThree from "../../common/images/ser-n-3.png";

const features = [
  {
    id: 1,
    title: "Proven Strategy",
    heading: "Tailored Solutions for Your Business",
    description:
      " We analyze your business needs and market trends to create a customized strategy that ensures measurable growth and long-term success.",
    img: serOne,
    badgeColor: "bg-[#FFC300]",
  },
  {
    id: 2,
    title: "Robust Performance",
    heading: "Secure, Scalable, and Reliable",
    description:
      " Our technical foundation is built for high performance, ensuring seamless operations and the flexibility to scale as your business grows.",
    img: serTwo,
    badgeColor: "bg-[#FFC300]",
  },
  {
    id: 3,
    title: "Customer-Centric Focus",
    heading: "Enhancing User Experience",
    description:
      "We prioritize intuitive and engaging designs that create a smooth user experience, increasing customer satisfaction and driving conversions.",
    img: serThree,
    badgeColor: "bg-[#FFC300]",
  },
];

const FeaturesSection = () => {
  return (
    <div className="bg-gradient-to-b from-[#F2FBFE] to-white">
    <section className="max-w-[1280px] mx-auto md:px-10 px-5 md:py-10 py-7">
    <h2 className="text-3xl md:text-5xl text-center small:text-4xl font-bold text-black">
    Why Choose Binary Ops
      </h2>
      <div className="underline w-1/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-secondary">
        <p className="h-[5px] rounded-xl bg-yellow-400 w-[50%]"></p>
      </div>
      <p className="text-center text-black mt-2">
      Driving innovation with strategic expertise and technical excellence      </p>

      <div className="grid md:grid-cols-3 gap-3 mt-12 max-w-[1080px] mx-auto">
        {features.map((feature) => (
          <div className="p-5 relative bg-white border-blue-500 shadow-md border-[1px] rounded-md pt-14 pb-5">
            <div
              key={feature.id}
              className="border rounded-lg shadow-md overflow-hidden bg-[#F9F9F9] h-full"
            >
              <div className="">
                <img
                  src={feature.img}
                  alt={feature.title}
                  className="w-full h-52 object-cover"
                />
                <span
                  className={`absolute top-3 left-3 text-white px-3 py-1 text-sm font-semibold rounded-full ${feature.badgeColor}`}
                >
                  {feature.title}
                </span>
              </div>
              <div className="p-2 text-start">
                <h3 className="small:text-[17px] text-sm  font-semibold text-blue-700">
                  {feature.heading}
                </h3>
                <p className="h-[5px] rounded-xl bg-yellow-400 my-2 w-[30%]"></p>

                <p className="text-gray-600 text-sm mt-2">
                  {feature.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
    </div>
  );
};

export default FeaturesSection;
